import { AgencyType } from '@/entities/auth/agency-type.enum';
import { UserRole } from '@/entities/auth/user-role.enum';
import type { User } from '@/entities/auth/user.entity';
import { CompanyInvoicingType } from '@carvia/ros-client-types';
import { calculateRentalDays } from '@/utils/calculate-rental-days';

export { nextLongTermSearchValue } from './long-term-search-value';

export const LONG_TERM_MIN_DAYS = 30;

export function isCustomerPaidPartner(partner?: User | null): boolean {
  if (!partner) {
    return true;
  }
  if (partner.role === UserRole.AGENCY) {
    return partner.agencyType === AgencyType.AGENCY_ON_COMMISSION_BASIS;
  }
  if (partner.role === UserRole.COMPANY) {
    const invoicingType = partner.agencySettings?.companyInvoicingType;
    return !invoicingType || invoicingType === CompanyInvoicingType.REGULAR;
  }
  return true;
}

export function isLongTermDurationTooShort(startDate: Date, endDate: Date): boolean {
  return calculateRentalDays(startDate, endDate) < LONG_TERM_MIN_DAYS;
}
